export default __webpack_public_path__ + "static/media/screen3.3c2bb03f.png";